import { createContext, useContext } from "react";
import { AuthorSinglePageProps } from "@/types/strapi/author";

export type AuthorSinglePageContextType = AuthorSinglePageProps | null;

export const AuthorSinglePageContext = createContext<AuthorSinglePageContextType>(null);

export const useAuthorSinglePageContext = () => useContext(AuthorSinglePageContext);
